import * as React from 'react';
import styled from '@emotion/styled';
import type { KdsTicket } from '../../../redux/tickets/types/ticket';
import { isOrderPaid } from '../../tickets/utils';
import { ReactComponent as ToPayIcon } from '../../../icons/TO_PAY.svg';
import { theme as mainTheme } from '../../../theme';

const Container = styled.div`
    border-radius: 7px;
    height: 200px;
    background-color: ${({ theme }) => theme.color.white};
    position: relative;
    width: 100%;
    align-self: start;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
`;

const Label = styled.p`
    ${({ theme }) => theme.font.familyBold};
    color: ${({ theme }) => theme.color.black};
    font-size: 72px;
`;

type Props = {
    ticket: KdsTicket;
};

const DisplayedOrder: React.FunctionComponent<React.PropsWithChildren<Props>> = ({ ticket }) => {
    const { ticketNumber, orderStatus } = ticket;
    const shouldDisplayToPayIcon = !isOrderPaid(orderStatus);

    return (
        <Container>
            <Label data-testid="order-ready">{ticketNumber}</Label>
            {shouldDisplayToPayIcon && (
                <ToPayIcon
                    data-testid="to-pay-icon"
                    width={64}
                    height={64}
                    stroke={mainTheme.color.black}
                    fill={mainTheme.color.black}
                    strokeWidth={0.5}
                    style={{ marginLeft: '8px' }}
                />
            )}
        </Container>
    );
};

export default DisplayedOrder;
